import { Timebar } from './index';
import { container } from '@graphistry/falcor-react-redux';

export const withTimebarListContainer = container({
    renderLoading: true,
    fragment({ templates = [], ...timebars } = {}, props = {}) {
        return `{
            id, name, length,
            ...${Timebar.fragments(timebars, {
                [timebars.length - 1]: {
                    width: Math.max(0, (props.width) || 0),
                    height: Math.max(0, (props.height - 30) || 0)
                }
            })},
            templates: {
                length, [0...${templates.length}]: {
                    name, isInternal, dataType, identifier, componentType
                }
            },
        }`;
    },
    mapFragment: (timebars = {}, props, $falcor) => ({
        $falcor,
        timebars,
        id: timebars.id,
        name: timebars.name,
        templates: timebars.templates
    })
});
